import { render, staticRenderFns } from "./TherapiesFields.vue?vue&type=template&id=5f96d133&"
import script from "./TherapiesFields.vue?vue&type=script&lang=js&"
export * from "./TherapiesFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports